import * as React from 'react'

function SvgMufg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_209_121392)">
        <path
          d="M30.5102 21.7183V15.6303L27.9061 19.6068H27.8357L25.1965 15.7006V21.7887H23.2257V12.3576H25.4076L27.8709 16.2989L30.299 12.3576H32.4104V21.7535H30.5101V21.7183H30.5102ZM38.0058 21.8238C35.5073 21.8238 34.0293 20.4161 34.0293 17.7065V12.3576H36V17.6713C36 19.1845 36.8094 19.9587 38.0411 19.9587C39.2728 19.9587 40.0822 19.2197 40.0822 17.7416V12.3575H42.0177V17.6361C42.0176 20.4514 40.5044 21.8238 38.0058 21.8238ZM45.5366 14.2929V16.2637H49.6539V18.2343H45.5366V21.7535H43.5659V12.3576H50.8151V14.3282H45.5365V14.2929H45.5366ZM56.0587 21.859C53.1731 21.859 51.2023 19.8179 51.2023 17.0731V17.0379C51.2023 14.3987 53.2434 12.2168 56.0587 12.2168C57.7478 12.2168 58.7332 12.6743 59.6833 13.4837L58.3812 15.0321C57.6775 14.4338 57.0793 14.0818 55.9883 14.0818C54.5103 14.0818 53.349 15.4191 53.349 16.9675V17.0379C53.349 18.7622 54.475 19.9939 56.129 19.9939C56.8681 19.9939 57.4311 19.818 58.0294 19.4309V18.1992H55.8827V16.2285H60V20.3459C59.0499 21.1904 57.7831 21.859 56.0587 21.859Z"
          fill="#5A5A5A"
        />
        <path
          d="M12.7742 10C11.7537 10 10.7684 10.2111 9.88855 10.5982C9.04403 10.2112 8.05865 10 7.03805 10C3.16715 10 0 13.1318 0 17.0381C0 20.909 3.16715 24.0762 7.03805 24.0762C8.05855 24.0762 9.04394 23.8651 9.92377 23.4779C10.8035 23.865 11.7536 24.0762 12.8094 24.0762C16.6804 24.0762 19.8474 20.909 19.8474 17.0381C19.8123 13.1318 16.6804 10 12.7742 10ZM9.92377 23.4076C6.40464 23.4076 3.55415 20.5571 3.55415 17.038C3.55415 13.5189 6.40464 10.6684 9.92377 10.6684C13.4428 10.6684 16.2933 13.5189 16.2933 17.038C16.2933 20.5572 13.4077 23.4076 9.92377 23.4076ZM12.8446 17.0381C12.8456 17.4219 12.7707 17.8021 12.6242 18.1569C12.4778 18.5117 12.2627 18.8341 11.9913 19.1055C11.7199 19.3769 11.3975 19.592 11.0427 19.7385C10.6879 19.8849 10.3077 19.9598 9.92387 19.9589C8.30507 19.9589 7.00303 18.6568 7.00303 17.0381C7.00303 15.4193 8.30507 14.1173 9.92387 14.1173C10.3077 14.1164 10.6879 14.1913 11.0427 14.3377C11.3975 14.4841 11.7199 14.6992 11.9913 14.9706C12.2627 15.2421 12.4778 15.5644 12.6242 15.9192C12.7707 16.274 12.8456 16.6542 12.8446 17.0381Z"
          fill="#E60000"
        />
      </g>
      <defs>
        <clipPath id="clip0_209_121392">
          <rect width="60" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgMufg
